import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType, GaTrackingEventName } from '../../constants';
import { ApplicationEventType } from '~shared/modules/application-event/constants';

export class GATrackingEditorialLinkNavigationClickEvent implements GATrackingEvent {
  constructor(private label: string) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.EditorialLinkNavigationClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.EditorialLinkNavigationClick,
      gtmCustom: {
        category: ApplicationEventType.Navigation,
      },
      label: this.label,
    };
  }
}
